import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import { allocationTagService } from './services/allocationTagService';
import type { AllocationTagFilters } from './types/AllocationTag';

export const allocationTagQueries = {
  all: () => ['allocation-tag'] as const,

  lists: () => [...allocationTagQueries.all(), 'list'] as const,
  list: (filters: AllocationTagFilters) =>
    queryOptions({
      queryKey: [...allocationTagQueries.lists(), filters] as const,
      queryFn: ({ signal }) => allocationTagService.list(filters, signal),
      placeholderData: keepPreviousData,
    }),
};
